export const SEND_DIRECT_MESSAGE_REQUEST = 'SEND_DIRECT_MESSAGE_REQUEST';
export const SEND_DIRECT_MESSAGE_SUCCESS = 'SEND_DIRECT_MESSAGE_SUCCESS';
export const SEND_DIRECT_MESSAGE_FAILURE = 'SEND_DIRECT_MESSAGE_FAILURE';